<script setup lang="ts">
import type { HeaderProps } from '/#/components/base/header'

import isUndefined from 'lodash-es/isUndefined'

import { filterArrayWithShow } from '/@/utils/array'
import { isEmpty } from '/@/utils/is'

const { t } = useI18n()

const props = withDefaults(defineProps<HeaderProps>(), {
  contentHeaderPosition: 'start',
  variant: 'page',
  showActions: true,
  actResponsive: false,
})

/**
 * @var appearance
 * @description It sets header icon will appear according to incoming props.
 */
const appearance = computed(() => [
  props.description && 'title-icon',
  props.iconBorder && 'icon-border',
])

const filteredActions = computed(() => filterArrayWithShow(props.actionList ?? []))
</script>

<template>
  <div>
    <div
      v-if="variant === 'page'"
      class="page-header-container"
      :class="[
        noVerticalPadding && '!py-0',
        noHorizontalPadding && '!px-0',
        noPadding && '!p-0',
      ]"
    >
      <div name="header">
        <Breadcrumb v-if="!isUndefined(breadcrumb)" v-bind="breadcrumb" />
        <div v-else class="header">
          <div
            v-if="icon"
            class="flex-shrink-0"
            :class="appearance"
           
          >
            <Icon :name="icon" :size="iconBorder ? 'sm' : 'lg'" />
          </div>
          <div class="title-part" :class="[actResponsive && 'act-responsive']">
            <h3>{{ title }}</h3>
            <p v-if="description">{{ description }}</p>
          </div>
          <Badge
            v-if="isBeta"
            :label="t('common.beta').toLocaleUpperCase()"
            color="indigo"
            variant="soft"
            rounded
          />
        </div>
      </div>

      <div v-if="!isEmpty(filteredActions) || showActions" class="action-wrapper">
        <slot name="action">
          <div
            v-if="actionList && showActions"
            class="action-part"
           
          >
            <Button
              v-for="button in filteredActions"
              :key="button.key"
              v-bind="button"
              @click="button.action"
              @approve="button.approve"
            />
          </div>
        </slot>
      </div>
      <slot />
    </div>
    <div
      v-else
      class="content-header-container"
      :class="[`justify-${contentHeaderPosition}`]"
     
    >
      <div class="content-header-wrapper">
        <div class="content-header-title">
          {{ title }}
        </div>
        <div
          v-if="!isEmpty(description)"
          class="content-description"
         
        >
          {{ description }}
        </div>
      </div>

      <div><slot name="action-content" /></div>
    </div>
  </div>
</template>
